import { NgModule } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddCategoryDialogComponent } from './components/add-category-dialog/add-category-dialog.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AddItemDialogComponent } from './components/add-item-dialog/add-item-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { OrderDetailsDialogComponent } from './components/order-details-dialog/order-details-dialog.component';
import { RefundDialogComponent } from './components/refund-dialog/refund-dialog.component';
import { MatSelectModule } from '@angular/material/select';
import { EditMenuDialogComponent } from './components/edit-menu-dialog/edit-menu-dialog.component';

@NgModule({
  declarations: [
    AddCategoryDialogComponent,
    AddItemDialogComponent,
    ConfirmDialogComponent,
    OrderDetailsDialogComponent,
    RefundDialogComponent,
    EditMenuDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatDividerModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    MatSelectModule,
    JsonPipe,
  ],
  exports: [
    AddCategoryDialogComponent,
    FontAwesomeModule,
    OrderDetailsDialogComponent,
    RefundDialogComponent,
  ],
})
export class SharedModule {}
